import React, { memo } from 'react';
import map from 'lodash/map';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TableChartIcon from '@material-ui/icons/TableChart';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import { useHistory } from 'react-router-dom';

function Sidebar () {
  const history = useHistory()

  const menus = [
    { icon: <TableChartIcon/>, to: '/dashboard/users', name: 'Пользователи' },
    { icon: <EqualizerIcon/>, to: '/dashboard/analytics', name: 'События' },
    { icon: <EqualizerIcon/>, to: '/dashboard/analytics/client-funnel', name: 'Воронка клиентов' },
    { icon: <EqualizerIcon/>, to: '/dashboard/analytics/pro-funnel', name: 'Воронка профи' },
    { icon: <EqualizerIcon/>, to: '/dashboard/analytics/top-pro-links', name: 'Топ про ссылок' },
    { icon: <EqualizerIcon/>, to: '/dashboard/analytics/statistic', name: 'Статистика' },
    { icon: <TableChartIcon/>, to: '/dashboard/orders', name: 'Заказы' },
  ]

  return map(menus, (menu, key) => (
      <ListItem button key={key} onClick={() => history.push(menu.to)}>
        <ListItemIcon>
          {menu.icon}
        </ListItemIcon>
        <ListItemText primary={menu.name}/>
      </ListItem>
    )
  )
}

export default memo(Sidebar)



// WEBPACK FOOTER //
// ./src/template/Sidebar/index.jsx